import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LibService } from './libService';
import { AuthService } from '../auth/auth.service';
import { UserSessionService } from './user-session.service';
import { GuardService } from './guard.service';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CfgService extends BaseService {

    constructor(
        public override libService: LibService,
        public override authService: AuthService,
        public userSessionService: UserSessionService,
        public guardService: GuardService
    ) {
        super(libService, authService);
        this.baseApi = environment.rootApiFoundation;
        this.model = 'cfg';
    }

    /* ---------------------- CATEGORY ---------------------- */

    createCategory(data: any): Observable<any> {
        return this.libService.postDataWithAccessToken<any>(
            this.tokenId,
            data,
            this.baseApi,
            `${this.model}/categories`
        );
    }

    updateCategory(id: number, data: any): Observable<any> {
        return this.libService.putDataWithAccessToken<any>(
            this.tokenId,
            data,
            this.baseApi,
            `${this.model}/categories/${id}`
        );
    }

    /* ---------------------- MACROPHASE ---------------------- */

    createMacroPhase(data: any): Observable<any> {
        return this.libService.postDataWithAccessToken<any>(
            this.tokenId,
            data,
            this.baseApi,
            `${this.model}/macrophases`
        );
    }

    updateMacroPhase(id: number, data: any): Observable<any> {
        return this.libService.putDataWithAccessToken<any>(
            this.tokenId,
            data,
            this.baseApi,
            `${this.model}/macrophases/${id}`
        );
    }

    /* ---------------------- PHASE ---------------------- */

    createPhase(data: any): Observable<any> {
        return this.libService.postDataWithAccessToken<any>(
            this.tokenId,
            data,
            this.baseApi,
            `${this.model}/phases`
        );
    }

    updatePhase(id: number, data: any): Observable<any> {
        return this.libService.putDataWithAccessToken<any>(
            this.tokenId,
            data,
            this.baseApi,
            `${this.model}/phases/${id}`
        );
    }
}
